import React from 'react';
import { motion } from 'framer-motion';

const ConfirmModal = ({ ventaBuscada, estadisticasVenta, productosSeleccionados, montoTotal, formaDevolucion, procesando, onCancel, onConfirm }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <motion.div initial={{ scale: 0.95 }} animate={{ scale: 1 }} className="bg-white rounded-lg p-6 max-w-3xl w-full mx-4 max-h-[80vh] overflow-y-auto border border-gray-100">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">Confirmar Devolución</h3>

            <div className="grid grid-cols-2 gap-4 mb-4 p-4 bg-gray-50 rounded">
          <div>
            <p><strong>Venta ID:</strong> {ventaBuscada.id}</p>
            <p><strong>Cliente:</strong> {ventaBuscada.cliente?.nombre || 'Consumidor final'}</p>
            <p><strong>Fecha Venta:</strong> {new Date(ventaBuscada.createdAt).toLocaleDateString()}</p>
          </div>
          <div>
            <p><strong>Forma de devolución:</strong> <span className="ml-2 px-2 py-1 bg-gray-100 rounded text-sm">{formaDevolucion.replace('_', ' ').toUpperCase()}</span></p>
            <p><strong>Total Venta:</strong> ${ (estadisticasVenta.total_final ?? 0).toFixed(2) }</p>
            {estadisticasVenta.total_antes && <p className="text-sm text-gray-500">Antes: ${(estadisticasVenta.total_antes).toFixed(2)}</p>}
            <p><strong>Ya Devuelto:</strong> ${estadisticasVenta.total_ya_devuelto.toFixed(2)}</p>
          </div>
        </div>

        <h4 className="font-medium mb-2">Productos a devolver ({productosSeleccionados.length}):</h4>
        <div className="space-y-3 mb-4 max-h-60 overflow-y-auto">
          {productosSeleccionados.map(producto => (
            <div key={producto.id_producto} className="border p-3 rounded bg-white">
              <div className="flex justify-between items-start">
                <div className="flex-1">
                  <p className="font-semibold text-gray-900">{producto.nombre_producto}</p>
                  <div className="text-sm text-gray-600 mt-1">
                    <p><strong>Cantidad a devolver:</strong> {producto.cantidad_devuelta.toFixed(3)} <span className="text-gray-500">(de {producto.cantidad_original.toFixed(3)} original)</span></p>
                    {producto.cantidad_ya_devuelta > 0 && <p className="text-gray-600"><strong>Ya devuelto antes:</strong> {producto.cantidad_ya_devuelta.toFixed(3)}</p>}
                  </div>
                  <div className="text-sm mt-2 text-gray-700">
                    <p><strong>Precio unitario:</strong> ${producto.precio_unitario.toFixed(2)}</p>
                    <p><strong>Motivo:</strong> <em>{producto.motivo}</em></p>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-lg font-bold text-gray-900">${producto.monto_devolucion.toFixed(2)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="border-t pt-4 mb-6">
          <div className="p-4 rounded bg-white">
            <div className="flex justify-between items-center text-lg">
              <span className="font-semibold">TOTAL A DEVOLVER:</span>
              <span className="text-2xl font-bold">${montoTotal.toFixed(2)}</span>
            </div>
            <div className="text-sm text-gray-600 mt-2">
              <p>Nuevo total disponible para devolución: ${(estadisticasVenta.total_disponible_devolucion - montoTotal).toFixed(2)}</p>
            </div>
          </div>
        </div>

        <div className="flex gap-3 justify-end">
          <button onClick={onCancel} className="px-4 py-2 bg-gray-200 rounded">Cancelar</button>
          <button onClick={onConfirm} className="px-4 py-2 bg-red-600 text-white rounded" disabled={procesando}>{procesando ? 'Procesando...' : 'Confirmar Devolución'}</button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ConfirmModal;
